import { IonPage, IonContent} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";


class RefundFlow extends Component {

    render() {

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont">
                        <div className="guide-head">
                            <a href="/phone/refundTutelage">监护引导</a>
                            <a href="/phone/refundFlow" className="on">申请流程</a>
                            <a href="/h5accountRefund">点我申请</a>
                        </div>
                        <div className="guide_cont">
                            <h1 className="guide_cont_title">一、申请条件</h1>
                            <p>1、申请人应为被监护人的法定监护人；<br/>
                                2、申请人的被监护人年龄小于18周岁；<br/>
                                3、申请人应为中国大陆地区公民。</p>
                            <h1 className="guide_cont_title">二、申请方式</h1>
                            <p>1、申请人可通过91y游戏中心官网、移动端-“青少年成长护航”-“点我申请”页面上传所需信息材料进行申请；<br/>
                                2、申请人可通过电子邮件将所需信息材料发送至91y官方客服邮箱进行申请。邮箱：kefu@91y.com；<br/>
                                3、申请人可通过平台在线客服或专线电话来电咨询，客服专线：4008852091。 </p>
                            <h1 className="guide_cont_title">三、退款申请流程（仅适用于未成年人充值）</h1>
                            <p>1、填写监护人信息（监护人身份、姓名、身份证号码）及本人正常使用的手机号码；<br/>
                                2、监护人人脸识别验证；<br/>
                                3、提交退款游戏账号或ID及对应实名认证信息（姓名、身份证号码）、退款金额以及对应充值订单截图；<br/>
                                4、上传监护关系证明（监护人户口页、被监护人户口页）、未成年人充值行为说明等。</p>
                            <h1 className="guide_cont_title">四、申请进度查询</h1>
                            <p>1、您可通过我们的客服进行查询，随时了解申请进度。<br/>
                                2、如您对需要提交的资料或处理结果有疑问或需咨询其他问题，您可以随时联系我们，我们将由专人为您提供服务。
                            </p>
                            <h1 className="guide_cont_title">五、其他要求</h1>
                            <p>1、申请人应提交完整的申请材料，对未提供的信息要及时补充。<br/>
                                2、申请人应保证提交的信息真实有效，对于提供虚假信息或伪造证件，我司将保留进一步追究法律责任的权利。
                            </p>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(RefundFlow);
